import React, { useState } from 'react';
import { api } from '../../config/api';

const AddWordModal = ({ isOpen, onClose, onAdd, listId }) => {
  const [wordData, setWordData] = useState({
    original: '',
    translation: '',
    notes: ''
  });
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const newWord = await api.createWord(listId, wordData);
      onAdd(newWord);
      onClose();
      setWordData({ original: '', translation: '', notes: '' });
      setError('');
    } catch (err) {
      setError(err.message || 'Wystąpił błąd podczas dodawania słówka');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md relative">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 text-neutral-400 hover:text-neutral-600 transition-colors"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        
        <div className="p-4">
          <h2 className="text-sm font-semibold mb-4">Dodaj nowe słówko</h2>
          
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="block text-xs font-medium text-neutral-700 mb-1">Słówko</label>
              <input
                type="text"
                value={wordData.original}
                onChange={(e) => setWordData({ ...wordData, original: e.target.value })}
                className="w-full px-3 py-2 text-xs border border-neutral-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500"
                required
              />
            </div>

            <div className="mb-3">
              <label className="block text-xs font-medium text-neutral-700 mb-1">Tłumaczenie</label>
              <input
                type="text"
                value={wordData.translation}
                onChange={(e) => setWordData({ ...wordData, translation: e.target.value })}
                className="w-full px-3 py-2 text-xs border border-neutral-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500"
                required
              />
            </div>

            <div className="hidden mb-4">
              <label className="block text-xs font-medium text-neutral-700 mb-1">Notatki (opcjonalnie)</label>
              <textarea
                value={wordData.notes}
                onChange={(e) => setWordData({ ...wordData, notes: e.target.value })}
                className="w-full px-3 py-2 text-xs border border-neutral-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary-500 h-20 resize-none"
                rows="2"
              />
            </div>

            {error && (
              <div className="mb-4 p-3 text-sm bg-red-50 text-red-600 rounded-md">
                {error}
              </div>
            )}

            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={onClose}
                className="px-3 py-1.5 text-xs font-medium text-neutral-700 bg-white border border-neutral-300 rounded-md hover:bg-neutral-50 transition-colors"
              >
                Anuluj
              </button>
              <button
                type="submit"
                className="px-3 py-1.5 text-xs font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 transition-colors"
              >
                Dodaj
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddWordModal; 